<template>
  <v-container
    class="fill-height p-0"
  >
    <v-row
      align="center"
      justify="center"
      no-gutters
    >
      <v-col
        cols="12"
        sm="8"
        md="8"
      >
        <v-img
          max-height="220"
          max-width="400"
          contain
          class="mx-auto mb-4"
          :src="this.logo"
        />
        <v-card
          class="elevation-12 card"
        >
          <v-window
            v-model="step"
          >
            <v-window-item
              :value="1"
            >
              <v-row>
                <v-col
                  cols="12"
                  md="12"
                  class="pt-6 pb-6"
                >
                  <v-card-title
                    class="justify-center"
                  >
                    {{ $t('login') }}
                  </v-card-title>
                  <v-card-text>
                    <v-form
                      ref="form"
                      v-model="valid"
                      lazy-validation
                      @submit.prevent="login"
                    >
                      <v-col cols="8" offset="2">
                        <v-text-field
                          v-model="email"
                          :error-messages="errors.email"
                          :rules="emailRules"
                          type="email"
                          name="email"
                          autocomplete="username"
                          label="Correo Electrónico"
                          placeholder="ejemplo@dominio.com"
                          append-icon="mdi-account"
                          :color="bgColor"
                          required
                        />
                      </v-col>

                      <v-col cols="8" offset="2">
                        <v-text-field
                          v-model="password"
                          :error-messages="errors.password"
                          :type="showPassword ? 'text' : 'password'"
                          name="password"
                          autocomplete="current-password"
                          label="Contraseña"
                          placeholder=""
                          :append-icon="showPassword ? 'mdi-eye-off' : 'mdi-eye'"
                          :rules="passwordRules"
                          :color="bgColor"
                          @click:append="showPassword = !showPassword"
                        />
                      </v-col>
                      <v-col cols="8" offset="2">
                        <v-row>
                          <v-col cols="6">
                            <v-checkbox
                              v-model="remember"
                              class="mt-0 pt-0"
                              name="remember"
                              :color="bgColor"
                              :label="$t('remember_me')"
                              hide-details
                            />
                          </v-col>
                          <v-col cols="6">
                            <router-link
                              :to="{ name: 'password.request' }"
                              class="small ml-auto my-auto"
                            >
                              {{ $t('forgot_password') }}
                            </router-link>
                          </v-col>
                        </v-row>
                      </v-col>
                      <v-row>
                        <v-col cols=8 class="text-center mt6" offset="2">
                          <v-btn
                            :disabled="!valid || loading"
                            :loading="loading"
                            class="white--text"
                            :color="bgColor"
                            @click="validate"
                          >
                            {{ $t('login') }}
                          </v-btn>
                        </v-col>
                      </v-row>
                    </v-form>
                  </v-card-text>
                </v-col>
              </v-row>
            </v-window-item>

          </v-window>
        </v-card>
      </v-col>
    </v-row>
  </v-container>
<!--  <div class="row">-->
<!--    <div class="col-lg-4 m-auto">-->
<!--      <card :title="">-->

<!--      </card>-->
<!--    </div>-->
<!--  </div>-->
</template>

<script>
import Vue from 'vue';
import { VueReCaptcha } from 'vue-recaptcha-v3';

Vue.use(VueReCaptcha, { siteKey: '6LeZYgUcAAAAAJJQhWBIy4-_1FkifSd0Vo-M49VQ' });

const REMEMBERED_EMAIL_KEY = 'remembered_email';

export default {
  middleware: 'guest',
  layout: 'auth',
  metaInfo() {
    return { title: this.$t('login') };
  },

  props: {
    action: { default: '' },
    fgColor: {
      type: String,
      default: 'white',
    },
  },

  data: () => ({
    valid: false,
    email: '',
    password: '',
    remember: false,
    showPassword: false,
    errores: '',
    step: 1,
    errors: [],
    emailRules: [
      (v) => !!v || 'El correo electrónico es requerido',
      (v) => /.+@.+\..+/.test(v) || 'Debe introducir un correo electrónico válido.',
    ],
    passwordRules: [
      (v) => !!v || 'La contraseña es requerida.',
    ],
    loading: false,
    logo: 'img/logo_hka.png',
  }),
  computed: {
    isEbipac() {
      const env = process.env.VUE_APP_ENV;
      return env === 'EBI' || env === 'ebipac';
    },
    bgColor() {
      return this.isEbipac ? '#0A3D91' : '#0084CA';
    },
  },
  mounted() {
    const url = window.location;
    if (this.isEbipac || url.href.includes('ebi-pac')) {
      this.logo = 'img/ebi-pac.png';
    }

    const rememberedEmail = window.localStorage.getItem(REMEMBERED_EMAIL_KEY);
    if (rememberedEmail) {
      this.email = rememberedEmail;
      this.remember = true;
    }
  },
  methods: {
    async login() {
      this.loading = true;

      const response = await window.axios.post('/api/login', {
        email: this.email,
        password: this.password,
        type: 'D',
      }).catch(() => null);

      if (!response) {
        this.loading = false;
        return;
      }

      const { data } = response;

      if (this.remember) {
        window.localStorage.setItem(REMEMBERED_EMAIL_KEY, this.email);
      } else {
        window.localStorage.removeItem(REMEMBERED_EMAIL_KEY);
      }

      // Save the token.
      this.$store.dispatch('auth/saveToken', {
        token: data.token,
        remember: this.remember,
      });

      // Fetch the user.
      await this.$store.dispatch('auth/fetchUser');
      await this.$store.dispatch('auth/fetchParams');
      this.loading = false;

      this.$router.push({ name: 'home' });
    },
    validate() {
      if (this.$refs.form.validate()) {
        this.snackbar = true;
        this.$recaptcha('login').then((token) => {
          if (token) {
            this.$recaptchaInstance.hideBadge();
            this.login();
          }
        });
      }
    },
  },
};
</script>
<style scoped>
.v-input__icon--double .v-input__icon {
  margin-left: -4.25rem !important;
}
a.no-text-decoration {
  text-decoration: none;
}
#signinup-form {
  max-width: 75rem;
}
.signup-form {
  max-width: 23rem;
  margin: 0 auto;
}
.card {
  overflow: hidden;
}
.vcenter {
  display: flex;
  align-items: center;
  justify-content: center;
}
</style>
